module.exports = __webpack_public_path__ + "img/01_white_dance.8598881b.gif";